import { defineMessages } from 'react-intl';

export default defineMessages({
    purchaseHeader: {
        id: 'ml.quoteandbind.common.confirmation.Thank you for your purchase',
        defaultMessage: 'Thank you for your purchase',
    },
    policyNumberMessage: {
        id: 'ml.quoteandbind.common.confirmation.Your policy number is',
        defaultMessage: 'Your policy number is: {policyNumber}',
    },
    policyInfoSentByEmail: {
        id: 'ml.quoteandbind.common.confirmation.Information about your policy has been sent to you at',
        defaultMessage: 'Information about your policy has been sent to you at {emailAddress}',
    },
    idCardInfo: {
        id: 'ml.quoteandbind.common.confirmation.idCardInfo',
        defaultMessage: 'Your ID card(s) will be mailed to you within 5-7 business days. If you need ID cards now, create your account and print ID cards from the Documents page.'
    },
    printConfirmation: {
        id: 'ml.quoteandbind.common.confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    createOnlineAccount: {
        id: 'ml.quoteandbind.common.confirmation.Create Your Online Policy Account',
        defaultMessage: 'Create Your Online Policy Account'
    },
    accountEnablement: {
        id: 'ml.quoteandbind.common.confirmation.Creating an account enables you to:',
        defaultMessage: 'Creating an account enables you to:'
    },
    viewAndPrintIDAndDocs: {
        id: 'ml.quoteandbind.common.confirmation.View and print ID Cards and other policy documents',
        defaultMessage: 'View and print ID Cards and other policy documents'
    },
    viewAndPrintDocs: {
        id: 'ml.quoteandbind.common.confirmation.View and print policy documents',
        defaultMessage: 'View and print policy documents'
    },
    statusOfClaim: {
        id: 'ml.quoteandbind.common.confirmation.File and check the status of claims',
        defaultMessage: 'File and check the status of claims'
    },
    paymentsInfo: {
        id: 'ml.quoteandbind.common.confirmation.Make payments and view payment history',
        defaultMessage: 'Make payments and view payment history'
    },
    customerService: {
        id: 'ml.quoteandbind.common.confirmation.Communicate with customer service',
        defaultMessage: 'Communicate with customer service'
    },
    createAccount: {
        id: 'ml.quoteandbind.common.confirmation.CREATE ACCOUNT',
        defaultMessage: 'CREATE ACCOUNT'
    },
    importantReminders: {
        id: 'ml.quoteandbind.common.confirmation.Important reminders for you',
        defaultMessage: 'Important reminders for you'
    },
    watchMailbox: {
        id: 'ml.quoteandbind.common.confirmation.Watch your email inbox for more information.',
        defaultMessage: 'Watch your email inbox for more information.'
    },
    notifyCurrentCarrier: {
        id: 'ml.quoteandbind.common.confirmation.notifyCurrentCarrier',
        defaultMessage: 'Remember to notify your current carrier of your new policy with us so they can cancel your policy on the effective date listed above.'
    },
    bundlingPolicy: {
        id: 'ml.quoteandbind.common.confirmation.Contact an agent to save more by bundling your policies.',
        defaultMessage: 'Contact an agent to save more by bundling your policies.'
    },
    bundlingPolicyQB: {
        id: 'ml.quoteandbind.common.confirmation.Contact a representative to save more by bundling your policies.',
        defaultMessage: 'Contact a representative to save more by bundling your policies.'
    },
    findCarcoLocations: {
        id: 'ml.quoteandbind.common.confirmation.Find Carco Locations',
        defaultMessage: 'Find Carco Locations'
    },
    yourPolicyWithProduct: {
        id: 'ml.quoteandbind.common.confirmation.Your X Policy',
        defaultMessage: 'Your {productName} Policy'
    },
    policyDetailsHeader: {
        id: 'ml.quoteandbind.common.confirmation.POLICY DETAILS',
        defaultMessage: 'POLICY DETAILS'
    },
    policyDetailsPolicyNumber: {
        id: 'ml.quoteandbind.common.confirmation.Policy #',
        defaultMessage: 'Policy #: {policyNumber}'
    },
    periodStartDate: {
        id: 'ml.quoteandbind.common.confirmation.Effective Date:',
        defaultMessage: 'Effective Date: {effectiveDate}'
    },
    periodExpirationDate: {
        id: 'ml.quoteandbind.common.confirmation.Expiration Date:',
        defaultMessage: 'Expiration Date: {expirationDate}'
    },
    paymentMethodHeader: {
        id: 'ml.quoteandbind.common.confirmation.PAYMENT METHOD',
        defaultMessage: 'PAYMENT METHOD'
    },
    bankAccountPaymentMethod: {
        id: 'ml.quoteandbind.common.confirmation.Bank account',
        defaultMessage: 'Bank account'
    },
    cardPaymentMethod: {
        id: 'ml.quoteandbind.common.confirmation.Credit/Debit card',
        defaultMessage: 'Credit/Debit card'
    },
    billMortgageedPaymentMethod: {
        id: 'ml.quoteandbind.common.confirmation.Bill mortgagee',
        defaultMessage: 'Bill mortgagee'
    },
    onlineOrMailPaymentMethod: {
        id: 'ml.quoteandbind.common.confirmation.Pay Online or By Mail',
        defaultMessage: 'Pay Online or By Mail'
    },
    payrollDeductionPaymentMethod: {
        id: 'ml.quoteandbind.common.confirmation.Payroll Deduction',
        defaultMessage: 'Payroll Deduction'
    },
    endingInXXX: {
        id: 'ml.quoteandbind.common.confirmation.Ending in XXX',
        defaultMessage: 'Ending in {accountNumber}'
    },
    downPayment: {
        id: 'ml.quoteandbind.common.confirmation.DOWN PAYMENT',
        defaultMessage: 'DOWN PAYMENT'
    },
    paymentAmount: {
        id: 'ml.quoteandbind.common.confirmation.Payment Amount',
        defaultMessage: 'Payment Amount:'
    },
    paymentDate: {
        id: 'ml.quoteandbind.common.confirmation.Payment Date',
        defaultMessage: 'Payment Date:'
    },
    confirmationNumber: {
        id: 'ml.quoteandbind.common.confirmation.Confirmation #',
        defaultMessage: 'Confirmation #:'
    },
    paymentMethod: {
        id: 'ml.quoteandbind.common.confirmation.Payment method:',
        defaultMessage: 'Payment method:'
    },
    insured: {
        id: 'ml.quoteandbind.common.confirmation.INSURED',
        defaultMessage: 'INSURED'
    },
    coInsured: {
        id: 'ml.quoteandbind.common.confirmation.CO-INSURED',
        defaultMessage: 'CO-INSURED'
    },
    propertyAddress: {
        id: 'ml.quoteandbind.common.confirmation.PROPERTY ADDRESS',
        defaultMessage: 'PROPERTY ADDRESS'
    },
    vehiclesHeader: {
        id: 'ml.quoteandbind.common.confirmation.VEHICLES',
        defaultMessage: 'VEHICLES'
    },
    vehicleNamedNonOwner: {
        id: 'ml.quoteandbind.common.confirmation.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    },
    registrationTechnicalIssues: {
        id: 'ml.quoteandbind.common.confirmation.We are currently experiencing technical issues with our online registration process.',
        defaultMessage: 'We are currently experiencing technical issues with our online registration process.'
    },
    congratsPolicy: {
        id: 'ml.quoteandbind.common.confirmation.congratsOnNewPolicyMessage',
        defaultMessage: '<strong> Congratulations on your new {productName} policy! </strong> We\'ve emailed your policy details to you.'
    },
    confirmationNamedNonOwnerTooltipContent: {
        id: 'ml.quoteandbind.common.confirmation.Named Non-Owner.tooltipContent',
        defaultMessage: 'A Named Non-Owner Coverage policy is for persons who do not own a vehicle or have one available for their use. This policy will provide Liability coverage when you drive a non-owned vehicle, whether that vehicle is borrowed or rented.'
    },
    createAccountStatement: {
        id: 'ml.quoteandbind.common.confirmation.Creating an account enables you to:',
        defaultMessage: 'Creating an account enables you to:'
    }
});
